import React from "react";
import StatusZonePage from "./views/StatusZonePage";
import { StatusZoneContextProvider } from "./StatusZoneView";
import StatusContents from "../../constants/contentFile.json";

const StatusZoneView = () => {
  return (
    <StatusZoneContextProvider>
      <StatusZonePage textContents={StatusContents.status} />
    </StatusZoneContextProvider>
  );
};
export default StatusZoneView;
